import { Command } from 'commander';
import { createConnectDbQueryCommand } from './query.js';

export function createConnectDbCommand(): Command {
    const cmd = new Command('db')
        .description('Database access commands');

    cmd.addCommand(createConnectDbQueryCommand());
    return cmd;
}

